import { ReactNode } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { getDateFnsLocale } from "shared/locale/getDateFnsLocale";
import { useMuiLocales, useUserLocale } from "shared/locale/hooks";

interface Props {
  children: ReactNode;
}

// Must not suspend: it sits above Okta's Security, which starts the auth check
// only after the first commit.
const DateLocalizationWrapper = ({ children }: Props) => {
  const userLocale = useUserLocale();
  const { pickers } = useMuiLocales();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={getDateFnsLocale(userLocale)}
      localeText={
        pickers.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      {children}
    </LocalizationProvider>
  );
};

export default DateLocalizationWrapper;
